import React from 'react';
import { marked } from 'marked';

marked.use({
  gfm: true,
  breaks: true,
  pedantic: false,
  hooks: {
    postprocess(html: string) {
      return html
        .replace(/<ul>/g, '<ul style="list-style-type:disc;padding-left:24px;">')
        .replace(/<li>/g, '<li style="display:list-item;">');
    },
  },
  renderer: {
    link({ href, text }: { href: string; text: string }) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:inherit;">${text}</a>`;
    },
  },
});

interface SourceEntry {
  url: string;
  title?: string;
}

/** Replace [N] numbered references with markdown links using the sources map. */
function resolveNumberedRefs(text: string, sourcesMap: Map<string, SourceEntry>): string {
  return text.replace(/\[(\d+)\]/g, (_m, num) => {
    const source = sourcesMap.get(num);
    if (!source) return _m;
    const label = (source.title || source.url).replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
    return `[${label}](${source.url})`;
  });
}

export function TextPart({
  text,
  sourcesMap,
}: {
  text: string;
  sourcesMap?: Map<string, SourceEntry>;
}) {
  if (!text.trim()) return null;

  const processed = sourcesMap?.size ? resolveNumberedRefs(text, sourcesMap) : text;
  const html = marked.parse(processed) as string;

  return (
    <div
      className="message-markdown"
      style={{ display: 'flex', flexDirection: 'column' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
